import * as form from '../form';

export const substanceThcUsage = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        FirstUse: form.datecontrol(xitem.FirstUse),
        RecentUse: form.datecontrol(xitem.RecentUse),
        NatureOfUse: form.textarea(xitem.NatureOfUse),
        UseWhileEmployed: form.branch(xitem.UseWhileEmployed),
        UseWithClearance: form.branch(xitem.UseWithClearance),
        UseWithClearanceExplanation: form.textarea(xitem.UseWithClearanceExplanation),
        UseInFutureClearanceOrSafety: form.branch(xitem.UseInFutureClearanceOrSafety),
        UseInFutureClearanceOrSafetyExplanation: form.textarea(xitem.UseInFutureClearanceOrSafetyExplanation),
        UseInFutureGovernment: form.branch(xitem.UseInFutureGovernment),
        UseInFutureGovernmentExplanation: form.textarea(xitem.UseInFutureGovernmentExplanation),
        Explanation: form.textarea(xitem.Explanation),
        HowManyTimes: form.text(xitem.HowManyTimes),
        Reason: form.textarea(xitem.Reason),
        UseWhileEmployedPosition: form.text(xitem.UseWhileEmployedPosition),
        UseWhileEmployedExplanation: form.textarea(xitem.UseWhileEmployedExplanation),
        Comments: form.textarea(data.Comments),
      },
    };
  });
  return {
    UsedThc: form.branch(data.UsedThc),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
